import { useEffect } from 'react';

/**
 * Hook to handle Escape key press for closing modals/popups
 * @param onEscape - Callback function to execute when Escape is pressed
 * @param enabled - Optional flag to enable/disable the listener (default: true)
 */
export function useEscapeKey(onEscape: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscape();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape, enabled]);
}

export default useEscapeKey;
